import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';

const IconEchartTooltip = ({ color = colors.black }) => {
    return <svg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect width='8' height='8' fill={color} />
    </svg>;
};

IconEchartTooltip.propTypes = {
    color: PropTypes.string,
};

export default IconEchartTooltip;
